module.exports = function() {
  return new Worker(__webpack_public_path__ + "8464734c3cc1a14137c2.worker.js");
};